/**
 * 📧 PÁGINA DE VERIFICACIÓN DE EMAIL
 * 
 * Ruta: /verify-email?token=xxx
 * 
 * Verifica el email del usuario usando el token del link
 */

import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail();
  }, []);

  const verifyEmail = async () => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('No se proporcionó un token de verificación válido.');
      return;
    }

    try {
      const response = await fetch(`/api/auth/verify-email?token=${token}`, {
        method: 'GET'
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(data.message || '¡Email verificado exitosamente!');
        
        // Si devuelve un token JWT, guardarlo
        if (data.token) {
          localStorage.setItem('token', data.token);
        }
        
        // Redirigir al login después de 3 segundos
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setStatus('error');
        setMessage(data.error || 'Error al verificar el email. El token puede ser inválido o haber expirado.');
      }
    } catch (error) {
      console.error('Error verificando email:', error);
      setStatus('error');
      setMessage('Error de conexión. Por favor, intenta de nuevo.');
    }
  };

  return (
    <div className="min-h-screen bg-morado flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {/* Logo */}
          <div className="text-center mb-6">
            <BrandLogo className="w-64 mb-4" />
            <h1 className="text-2xl font-bold text-gray-800">
              Verificación de Email
            </h1>
          </div>

          {/* Status */}
          <div className="text-center">
            {status === 'loading' && (
              <div>
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-morado border-t-transparent mb-4"></div>
                <p className="text-gray-600">
                  Verificando tu email...
                </p>
              </div>
            )}

            {status === 'success' && (
              <div>
                <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
                  <span className="text-4xl">✅</span>
                </div>
                <p className="text-green-700 font-semibold mb-2">
                  {message}
                </p>
                <p className="text-gray-600 text-sm">
                  Redirigiendo al inicio de sesión...
                </p>
              </div>
            )}

            {status === 'error' && (
              <div>
                <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
                  <span className="text-4xl">❌</span>
                </div>
                <p className="text-red-700 font-semibold mb-4">
                  {message}
                </p>
                <div className="space-y-2">
                  <button
                    onClick={() => navigate('/login')}
                    className="w-full px-6 py-3 bg-morado text-white rounded-lg font-semibold hover:shadow-lg transition"
                  >
                    Ir al inicio de sesión
                  </button>
                  <button
                    onClick={() => navigate('/')}
                    className="w-full px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition"
                  >
                    Volver al inicio
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-white/80 text-sm">
            <strong>Numerathum</strong> - Mi Brújula del Tiempo
          </p>
        </div>
      </div>
    </div>
  );
}

